import React, { useEffect, useState } from "react";
import { getEvents, addEvent, deleteEvent } from "../api";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({
    description: "",
    amount: "",
    category: "",
    date: new Date(),
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  async function fetchEvents() {
    const data = await getEvents();
    setEvents(data);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const newEvent = {
      ...form,
      amount: Number(form.amount),
      date: form.date.toLocaleDateString("fa-IR"), // 🔹 تاریخ شمسی
    };

    await addEvent(newEvent);
    setForm({ description: "", amount: "", category: "", date: new Date() });
    setEditingId(null);
    fetchEvents();
  }

  async function handleDelete(id) {
    await deleteEvent(id);
    fetchEvents();
  }

  function handleEdit(event) {
    setForm({
      description: event.description,
      amount: event.amount,
      category: event.category,
      date: new Date(event.date),
    });
    setEditingId(event.id);
  }

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white shadow-lg rounded-xl">
      <h1 className="text-2xl font-bold mb-4 text-center">مدیریت تراکنش‌ها</h1>

      {/* فرم افزودن */}
      <form onSubmit={handleSubmit} className="grid grid-cols-5 gap-3 mb-6">
        <input
          type="text"
          placeholder="توضیحات"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          className="border p-2 rounded col-span-1"
        />
        <input
          type="number"
          placeholder="مبلغ"
          value={form.amount}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
          className="border p-2 rounded col-span-1"
        />
        <input
          type="text"
          placeholder="دسته‌بندی"
          value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })}
          className="border p-2 rounded col-span-1"
        />

        {/* 🔹 انتخاب تاریخ شمسی */}
        <DatePicker
          value={form.date}
          onChange={(date) => setForm({ ...form, date })}
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          inputClass="border p-2 rounded w-full text-center"
        />

        <button
          type="submit"
          className="bg-green-500 hover:bg-green-600 text-white p-2 rounded col-span-1"
        >
          {editingId ? "ویرایش" : "افزودن"}
        </button>
      </form>

      {/* جدول */}
      <table className="w-full border border-gray-300 text-center">
        <thead className="bg-gray-200">
          <tr>
            <th className="p-2">شناسه</th>
            <th>توضیحات</th>
            <th>مبلغ</th>
            <th>دسته‌بندی</th>
            <th>تاریخ</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <tr key={event.id} className="border-t">
              <td className="p-2">{event.id}</td>
              <td>{event.description}</td>
              <td>{Number(event.amount).toLocaleString("fa-IR")}</td>
              <td>{event.category}</td>
              <td>{event.date}</td>
              <td className="space-x-2">
                <button
                  onClick={() => handleEdit(event)}
                  className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded"
                >
                  ویرایش
                </button>
                <button
                  onClick={() => handleDelete(event.id)}
                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
